import { useCurrenciesQuery } from '../api/queries'
import { useCurrencyScope } from './CurrencyScope'

/** Selection of the nearest CurrencyScopeProvider, else backend default, else first available. */
export const useSelectedCurrency = (): string | undefined => {
	const [selected] = useCurrencyScope()
	const { data } = useCurrenciesQuery()

	if (selected && data?.currencies.includes(selected)) return selected

	return data?.default_currency ?? data?.currencies[0]
}
